import {StyleSheet} from 'react-native';
import Styles from '../../../Styles';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';

const {getMenuListCompnentsFontFamily, recentOrdersHideDetailsColors} =
  getDescriber();

export const styles = StyleSheet.create({
  container: {
    marginVertical: Styles.Spacing.m2 + Styles.Spacing.m1,
    marginHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
  },
  titleBar: {
    paddingHorizontal: Styles.Spacing.m2,
    paddingVertical: Styles.Spacing.m2 + Styles.Spacing.m1,
    alignItems: 'center',
    flexDirection: 'row',
  },
  showHideUnderLine: {
    alignSelf: 'flex-start',
    borderBottomColor: Styles.Colors.PayNew.primary01,
    borderBottomWidth: 1,
  },
  showHideText: {
    marginTop: Styles.Spacing.m2,
    color: Styles.Colors.PayNew.primary01,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontSize: Styles.Fonts.f0,
  },
  hideText: {
    color: Styles.Colors.PayNew.primary01,
    fontSize: Styles.Fonts.f1,
    fontFamily: getMenuListCompnentsFontFamily(),
  },
  dateText: {
    marginTop: Styles.Spacing.m2,
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
    color: Styles.Colors.PayNew.darkHuesBase04,
  },
  titleContainer: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m2,
  },
  titleText: {
    fontSize: Styles.Fonts.f1,
    color: Styles.darkColor,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontWeight: 'bold',
  },
  parentListImage: {
    width: 80,
    height: 73,
    padding: 2,
  },
  defaultImageContainer: {
    padding: 2,
    alignSelf: 'flex-start',
    borderRadius: Styles.Spacing.m2,
    borderWidth: 1,
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
  },
  imageContainer: {
    width: 83,
    aspectRatio: 1.15,
    borderRadius: 8,
    overflow: 'hidden',
  },
  parentImage: {
    width: 83,
    aspectRatio: 1.15,
  },
  itemPrice: {
    alignSelf: 'flex-end',
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f8,
    marginTop: Styles.Spacing.m2,
    fontWeight: 'bold',
    fontFamily: getMenuListCompnentsFontFamily(),
    paddingRight: Styles.Spacing.m0,
  },

  unavailable: {
    color: Styles.dangerColor,
    fontSize: Styles.Fonts.f13,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontWeight: '700',
  },

  sublistImage: {
    width: 69,
    height: 58,
    borderRadius: 8,
  },
  itemRowInnerParent: {
    flexDirection: 'row',
    flex: 1,
  },
  itemInnerRow: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: Styles.Spacing.m1,
    marginRight: Styles.Spacing.m2,
    marginLeft: Styles.Spacing.m2,
  },
  item: {
    marginLeft: Styles.Spacing.m2,
    color: Styles.darkColor,
    alignSelf: 'flex-start',
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m2,
    fontWeight: 'bold',
  },
  itemRight: {
    marginRight: Styles.Spacing.m2,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  itemCenter: {
    flex: 1,
    flexDirection: 'column',
  },
  modifierContainer: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m2,
    flexDirection: 'column',
  },
  modifierText: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
  },
  modifierPrice: {
    color: '#138665',
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
    marginRight: 36,
  },
  unavailableModifier: {
    textDecorationStyle: 'solid',
    textDecorationColor: Styles.dangerColor,
    textDecorationLine: 'line-through',
  },
});
